var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIconGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 14L10.3174 10M11.6931 6.66667C11.6931 7.2795 11.5686 7.88634 11.3266 8.45252C11.0846 9.01871 10.73 9.53316 10.2829 9.9665C9.83578 10.3998 9.305 10.7436 8.72084 10.9781C8.13668 11.2126 7.51058 11.3333 6.87829 11.3333C6.246 11.3333 5.6199 11.2126 5.03574 10.9781C4.45158 10.7436 3.9208 10.3998 3.4737 9.9665C3.02661 9.53316 2.67195 9.01871 2.42998 8.45252C2.18802 7.88634 2.06348 7.2795 2.06348 6.66667C2.06348 5.42899 2.57075 4.242 3.4737 3.36683C4.37666 2.49167 5.60132 2 6.87829 2C8.15526 2 9.37993 2.49167 10.2829 3.36683C11.1858 4.242 11.6931 5.42899 11.6931 6.66667Z",
    stroke: "#858593",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIconGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchIconGrey.b02d2a741b9b2536328899e0efb7b071.svg";